// extracted by mini-css-extract-plugin
export default {"appBar":"Header_appBar__5vnMp"};